import React, { useState } from 'react';
import './index.scss';

export default function Search({ iaEnabled, onSubmit }) {
  const [filterText, setFilterText] = useState('');

  const handleChangeFilterText = (text) => {
    setFilterText(text);
  };

  const handleClickButton = () => {
    onSubmit(filterText);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSubmit(filterText);
    }
  };

  return (
    <div>
      <div className="container-search-ia-preview">
        <p className="input-title">
          Digite uma frase para testar a inteligência artificial
        </p>
        <div className="container-input-ia-preview">
          <input
            disabled={!iaEnabled}
            className="input-search"
            value={filterText}
            onChange={(e) => handleChangeFilterText(e.target.value)}
            placeholder="Frase para teste"
            onKeyUp={(event) => handleKeyDown(event)}
          />
          <div className="container-btn">
            <button
              type="button"
              disabled={!iaEnabled}
              className="btn-search-ia-preview"
              onClick={handleClickButton}
            >
              Testar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
